import { Routes } from '@angular/router';
import { PaymentResultComponent } from 'app/pages/payment-result/payment-result.component';


// Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const CONTENT_ROUTES: Routes = [

  {
    path: 'gracias-por-su-compra',
    component: PaymentResultComponent
  },
  {
    path: '',
    loadChildren: () => import('../../auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    loadChildren: () => import('../../legal-stuff/legal-stuff.module').then(m => m.LegalStuffModule)
  },

];
